// --------- Минификация изображений - модули ---------------
// Core-файл импортируется в to-head.js
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes/plugins/attrchange/ls.attrchange";
import "./global/lazysizes-custom";

const cache = {};
function importAll(r) {
    r.keys().forEach((key) => (cache[key] = r(key)));
}

// -------- Бандл глобальных плагинов (не требующих импорта) ---------------
import "./global/global-bundler";
// -------------------------------------------------------------------------

// --------- Импортируем скрипты компонентов --------
importAll(require.context("../components/", true, /\.js$/));
// --------------------------------------------------
